import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Owners_ds_owners_navigation_gridService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { ownerStatusId?: number, fullTextSearch?: string }): 
  Promise<{ result: { Id?: number, LookupCode?: string, Name?: string, Notes?: string, Status?: { Label?: string }, LicenseplateCount?: { TotalLicenseplates?: number, Lot?: { Material?: { Project?: { OwnerId?: number } } } }, ProjectCount?: { TotalProjects?: number, Owner?: { Id?: number } }, MaterialCount?: { TotalMaterials?: number, Project?: { Owner?: { Id?: number } } } }[] }> 
  {
    let url = `${environment.backendUrl}api/Owners/datasources/ds_owners_navigation_grid/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { ownerStatusId?: number, fullTextSearch?: string, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, LookupCode?: string, Name?: string, Notes?: string, Status?: { Label?: string }, LicenseplateCount?: { TotalLicenseplates?: number, Lot?: { Material?: { Project?: { OwnerId?: number } } } }, ProjectCount?: { TotalProjects?: number, Owner?: { Id?: number } }, MaterialCount?: { TotalMaterials?: number, Project?: { Owner?: { Id?: number } } } }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/Owners/datasources/ds_owners_navigation_grid/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { ownerStatusId?: number, fullTextSearch?: string, $keys: number[] }): 
  Promise<{ result: { Id?: number, LookupCode?: string, Name?: string, Notes?: string, Status?: { Label?: string }, LicenseplateCount?: { TotalLicenseplates?: number, Lot?: { Material?: { Project?: { OwnerId?: number } } } }, ProjectCount?: { TotalProjects?: number, Owner?: { Id?: number } }, MaterialCount?: { TotalMaterials?: number, Project?: { Owner?: { Id?: number } } } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Owners/datasources/ds_owners_navigation_grid/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      ownerStatusId?: number, fullTextSearch?: string    }) {
      return false;
    }
}
